import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { FLAVORS, FLAVOR_PILLS } from './salesData';

/** Pequeñas variaciones de composición para que no se lea como plantilla. */
const TILT = ['sm:-rotate-1', 'sm:rotate-1', 'sm:-rotate-1', 'sm:rotate-1', 'sm:-rotate-1'];

/**
 * VARIEDAD. Escaparate de pastelería: fotografía grande de cookies abiertas.
 * La primera variedad manda con una tarjeta a doble ancho y texto sobre la foto.
 */
export function FlavorsSection() {
  const [hero, ...rest] = FLAVORS;
  return <section id="sabores" className="scroll-mt-24 overflow-hidden bg-ivory py-14 sm:py-20" aria-labelledby="flavors-title" data-id="element-117" data-mp="3e52jotun54ry">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-118" data-mp="34dy720sftw0a">
        <div className="max-w-2xl" data-id="element-119" data-mp="34bbx5ui2r4ew">
          <SectionTag data-id="element-120" data-mp="5nfuku64yz09">Los sabores</SectionTag>
          <h2 id="flavors-title" className="mt-4 font-display text-[1.95rem] leading-[1.06] text-charcoal sm:text-[2.7rem]" data-id="element-121" data-mp="5p93kg481vbf">
            Así se ven por dentro
          </h2>
          <p className="mt-4 font-sans text-[0.95rem] leading-relaxed text-charcoal/65" data-id="element-122" data-mp="zq73g36y9n5l">
            Cada variedad tiene su propia receta completa. Estas son solo algunas de las cien.
          </p>
        </div>

        {/* Variedad protagonista: la foto ocupa todo y el texto vive encima. */}
        <motion.figure initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.25
      }} transition={{
        duration: 0.32,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mt-9 overflow-hidden rounded-5xl shadow-bakery" data-id="element-123" data-mp="uv1hj4djs8hi">
          <img src={hero.image} alt={hero.alt} loading="lazy" decoding="async" className="aspect-[4/5] w-full object-cover sm:aspect-[16/9]" data-id="element-124" data-mp="by8qlerurjqc" />
          <figcaption className="absolute inset-x-0 bottom-0 bg-charcoal/65 px-5 py-5 backdrop-blur-sm sm:px-9 sm:py-7" data-id="element-125" data-mp="26c1cy8v6z3fr">
            <span className="font-sans text-[0.58rem] font-bold uppercase tracking-editorial text-gold-pale" data-id="element-126" data-mp="24w5komwuasof">
              {hero.tag}
            </span>
            <h3 className="mt-1.5 font-display text-[1.5rem] leading-tight text-ivory sm:text-[2.2rem]" data-id="element-127" data-mp="1zydtjv40rala">
              {hero.name}
            </h3>
            <p className="mt-1.5 max-w-md font-sans text-[0.86rem] leading-snug text-ivory/75 sm:text-[0.98rem]" data-id="element-128" data-mp="1pywptj8bv6ry">
              {hero.note}
            </p>
          </figcaption>
        </motion.figure>

        <ul className="mt-5 grid grid-cols-2 gap-4 sm:grid-cols-3 sm:gap-6 lg:grid-cols-5" data-id="element-129" data-mp="2ink8d71ozi1t">
          {rest.map((flavor, index) => <motion.li key={flavor.id} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.25
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: index % 3 * 0.04
        }} className={`${TILT[index % TILT.length]} transition-transform duration-200 ease-out hover:rotate-0`} data-id="element-130" data-mp="2dtpni0acox15" data-mpi={index}>
              <figure className="group flex h-full flex-col" data-id="element-131" data-mp="3dxp25ccbr9o3">
                <div className="overflow-hidden rounded-4xl shadow-bakery-sm" data-id="element-132" data-mp="3itnv7d8llfuu">
                  <img src={flavor.image} alt={flavor.alt} loading="lazy" decoding="async" className="aspect-[4/5] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.04]" data-id="element-133" data-mp="3nubn014ni0q4" />
                </div>
                <figcaption className="mt-3.5 flex flex-1 flex-col px-1" data-id="element-134" data-mp="5gktxw1togwa">
                  <span className="font-sans text-[0.55rem] font-bold uppercase tracking-editorial text-berry" data-id="element-135" data-mp="adug92tx0cfw">
                    {flavor.tag}
                  </span>
                  <h3 className="mt-1 font-display text-[1.05rem] leading-tight text-charcoal sm:text-[1.15rem]" data-id="element-136" data-mp="kcto4j6uw41u">
                    {flavor.name}
                  </h3>
                  <p className="mt-1.5 font-sans text-[0.78rem] leading-snug text-charcoal/55 sm:text-[0.84rem]" data-id="element-137" data-mp="1h23yen49un7q">
                    {flavor.note}
                  </p>
                </figcaption>
              </figure>
            </motion.li>)}
        </ul>

        <div className="mt-12 rounded-5xl bg-pistacho-pale px-5 py-8 sm:px-10 sm:py-10" data-id="element-138" data-mp="1lwi0t9hcpulw">
          <p className="font-sans text-[0.6rem] font-bold uppercase tracking-editorial text-charcoal/50" data-id="element-139" data-mp="y6duuvgoxirq">
            Y muchos más entre las 100 variedades
          </p>
          <ul className="mt-4 flex flex-wrap gap-2.5" data-id="element-140" data-mp="176shpz9az5xc">
            {FLAVOR_PILLS.map(pill => <li key={pill} className="rounded-full bg-ivory px-4 py-2 font-sans text-[0.76rem] font-medium text-charcoal/75 shadow-[0_6px_14px_-10px_rgba(53,47,50,0.35)] sm:text-[0.85rem]" data-id="element-141" data-mp="1345yunum0vca">
                {pill}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}